import React, { useEffect, useState } from "react";
import { IQuestionnaire } from "../../types/questionnaire";

interface IQuestionnaireModal {
    title: string;
    action: string;
    onSave: (args: IQuestionnaire) => void;
    onCancel?: () => void;
    questionnaireData: IQuestionnaire;
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function QuestionnaireModal({
    title, isModalOpen, setIsModalOpen, questionnaireData, onSave, action, onCancel,
}: IQuestionnaireModal) {

    const [questionnaire, setQuestionnaire] = useState<IQuestionnaire>(questionnaireData);

    useEffect(() => {
        setQuestionnaire(questionnaireData);
    }, [questionnaireData])

    const handleSave = () => {
        onSave(questionnaire);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        setIsModalOpen(false);
    };

    return isModalOpen ? (
        <div className="imm_admin__custom_modal">
            <div className="custom_modal__container">
                <div className="custom_modal__header">
                    <h4>{title}</h4>
                </div>
                <div className="custom_modal__content">
                    <form className="content_form">
                        <div className="field">
                            <label htmlFor="name">Name</label>
                            <input type="text" id="name" name="name" placeholder="Enter name" value={questionnaire.name} onChange={(e) => setQuestionnaire({ ...questionnaire, name: e.target.value })} />
                        </div>
                        <div className="field">
                            <label htmlFor="version">Version</label>
                            <input type="text" id="version" name="version" placeholder="Enter version" value={questionnaire.version} onChange={(e) => setQuestionnaire({ ...questionnaire, version: e.target.value })} />
                        </div>
                        <div className="field">
                            <label htmlFor="description">Description</label>
                            <input type="text" id="description" name="description" placeholder="Enter description" value={questionnaire.description} onChange={(e) => setQuestionnaire({ ...questionnaire, description: e.target.value })} />
                        </div>
                        {action !== 'update' && (<div className="field">
                            <label htmlFor="code">Code</label>
                            <input type="text" id="code" name="code" placeholder="Enter code" value={questionnaire.quest_code} onChange={(e) => setQuestionnaire({ ...questionnaire, quest_code: e.target.value })} />
                        </div>)}
                    </form>
                </div>
                <div className="custom_modal__actions">
                    <button className="modal__decline_btn" onClick={handleCancel}>
                        Cancel
                    </button>
                    <button className="modal__accept_btn" onClick={handleSave}>
                        {action.charAt(0).toUpperCase() + action.slice(1)}
                    </button>
                </div>
            </div>
        </div>
    ) : null;
}